import { render } from "./HiFormItem.vue?vue&type=template&id=50c5625a&scoped=true"
import script from "./HiFormItem.vue?vue&type=script&lang=js"
export * from "./HiFormItem.vue?vue&type=script&lang=js"

import "./HiFormItem.vue?vue&type=style&index=0&id=50c5625a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c5625a"]])

export default __exports__